'use client'

import * as React from 'react'
import { cn } from '@/lib/utils'

// Chip — ui.jsx:98-119. Renders a button when clickable, a span otherwise.
export interface ChipProps {
  label: React.ReactNode
  /** Leading icon node (size ~14 to match the prototype). */
  icon?: React.ReactNode
  active?: boolean
  dashed?: boolean
  onClick?: (e: React.MouseEvent) => void
  title?: string
  small?: boolean
  className?: string
}

export function Chip({ label, icon, active, dashed, onClick, title, small, className }: ChipProps) {
  const cls = cn(
    'inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border transition-colors duration-150',
    small ? 'px-[9px] py-[3px] text-[11.5px]' : 'px-[11px] py-[5px] text-[12.5px]',
    active
      ? 'border-transparent bg-primary-container font-bold text-on-primary-container'
      : dashed
        ? 'border-dashed border-outline bg-transparent font-medium text-ink-secondary'
        : 'border-transparent bg-surface-high font-medium text-ink-secondary',
    onClick ? 'cursor-pointer' : 'cursor-default',
    className
  )
  const content = (
    <>
      {icon}
      <span>{label}</span>
    </>
  )
  if (onClick) {
    return (
      <button
        type="button"
        title={title}
        className={cls}
        onClick={(e) => {
          e.stopPropagation()
          onClick(e)
        }}
      >
        {content}
      </button>
    )
  }
  return (
    <span title={title} className={cls}>
      {content}
    </span>
  )
}
